import { MANDATORY_COURSE_STATUS } from "@utils/enums";

import { useApiOriginacao } from "./base/useApiOriginacao";

export type IApiCursoObrigatorioItem = {
  id: number;
  nome_curso: string;
  descricao: string | null;
  carga_horaria: string | null;
  status: MANDATORY_COURSE_STATUS;
  url_material: string | null;
  url_certificado: string | null;
};

export type IApiListarCursosObrigatoriosData = {
  nome?: string;
  status?: MANDATORY_COURSE_STATUS | "";
  page?: number;
  page_size?: number;
};

export type IApiListarCursosObrigatoriosResponse = {
  total: number;
  page: number;
  page_size: number;
  results: Array<IApiCursoObrigatorioItem>;
};

export type IApiIniciarCursoObrigatorioData = {
  curso_id: number;
};

export type IApiIniciarCursoObrigatorioResponse = {
  id: number;
  curso_id: number;
  nome_curso: string;
  status: MANDATORY_COURSE_STATUS;
  url_pdf: string | null;
};

export type IApiFinalizarCursoObrigatorioData = {
  curso_id: number;
};

export type IApiFinalizarCursoObrigatorioResponse = {
  id: number;
  curso_id: number;
  status: MANDATORY_COURSE_STATUS;
  finalizado_em: string | null;
};

export type IApiStatusBloqueioCursoObrigatorioResponse = {
  deve_bloquear: boolean;
  prazo_restante: number | null;
  bloqueado: boolean;
};

export const useApiListarCursosObrigatorios = () => {
  return useApiOriginacao<
    IApiListarCursosObrigatoriosResponse,
    IApiListarCursosObrigatoriosData
  >({
    method: "POST",
    url: "/cursos-obrigatorios/",
  });
};

export const useApiIniciarCursoObrigatorio = () => {
  return useApiOriginacao<
    IApiIniciarCursoObrigatorioResponse,
    IApiIniciarCursoObrigatorioData
  >({
    method: "POST",
    url: "/cursos-obrigatorios/iniciar/",
  });
};

export const useApiFinalizarCursoObrigatorio = () => {
  return useApiOriginacao<
    IApiFinalizarCursoObrigatorioResponse,
    IApiFinalizarCursoObrigatorioData
  >({
    method: "POST",
    url: "/cursos-obrigatorios/finalizar/",
  });
};

export const useApiStatusBloqueioCursoObrigatorio = () => {
  return useApiOriginacao<IApiStatusBloqueioCursoObrigatorioResponse>({
    method: "POST",
    url: "/cursos-obrigatorios/status-bloqueio/",
  });
};
